import React, { useState } from "react";
import { usePageTitle } from "@/utilities";
import { List, TextInput, useListContext, useTranslate } from "react-admin";
import { Grid } from "@mui/material";
import { Game } from "@/types";
import { DaysCheckBoxInput } from "@/components/dayscheckboxgroup";
import { AssignLocationDialog } from "@/components/dialogs";
import { GameCard } from "@/components/gamecard";

const gameFilters = (label: string) => [
  <TextInput source="q" label={label} alwaysOn key="search" />,
  <DaysCheckBoxInput source="dv" label="Jour de validité" key="day_validity" />,
];

const GameCardGrid: React.FC = () => {
  const { data, isLoading } = useListContext();
  const translate = useTranslate();
  const [openDialogLocation, setOpenDialogLocation] = useState(false);
  const [selectedGamePseudo, setSelectedGamePseudo] = useState<string>("");

  if (isLoading || !data) return null;

  return (
    <>
      <Grid container alignItems="stretch">
        {data.map((record: Game) => {
          return (
            <Grid
              size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
              key={record.id}
              sx={{ display: "flex", padding: 2 }}
            >
              <GameCard
                title={record.name}
                subtitle={record.description || ""}
                coverSrc={`/game-thumbnail-${record.pseudo}.png`}
                iconSrc={`/game-icon-${record.pseudo}.png`}
                rating={0}
                gamePseudo={record.pseudo}
                ctaLabel={translate("ra.gameoo.play")}
                onPlayClick={(p) => {
                  setSelectedGamePseudo(p);
                  setOpenDialogLocation(true);
                }}
              />
            </Grid>
          );
        })}
      </Grid>
      <AssignLocationDialog
        open={openDialogLocation}
        onClose={() => setOpenDialogLocation(false)}
        gamePseudo={selectedGamePseudo}
      />
    </>
  );
};

const GamesList: React.FC = () => {
  const translate = useTranslate();
  usePageTitle(translate("ra.gameoo.gameTitle"));

  return (
    <List
      filters={gameFilters(translate("ra.gameoo.gameSearch"))}
      sort={{ field: "created_at", order: "DESC" }}
      exporter={false}
    >
      <GameCardGrid />
    </List>
  );
};

export default GamesList;
